module.exports = Em.Mixin.create
  # ---
  # Обработка события change
  # ---
  installChangeHandler: (-> 
    $el = @$()
    $el.data('oldVal', $el.val())

    $el.bind "propertychange change click keyup input paste", (event) =>
      # Check if the value has changed
      if $el.data('oldVal') != $el.val()
        $el.data('oldVal', $el.val())
        @sendAction('onChange', $el.val())

      # Check if the keyup event is for the Enter key
      if event.type == 'keyup' and event.key == 'Enter'
        @sendAction('onSubmit', $el.val())
  ).on('didInsertElement')